import React from 'react';
import ReactDOM from 'react-dom/client';
import '@mantine/core/styles.css';
import { App } from './app/App';
import { captureInstallPrompt, registerAppSw } from './lib/sw';

// Before the first render, not as an import side effect: Chrome fires `beforeinstallprompt`
// early, and a listener attached after `createRoot` can miss it — which would mean the Me
// screen never offers Install on the one device that was ready to accept it.
captureInstallPrompt();

// PROD only. In dev the Vite server on :5173 proxies /api to the Worker on :8787, and a
// precached shell there makes every later edit look like it did not land.
if (import.meta.env.PROD) void registerAppSw();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
